import { safeAreaInsetsState } from '@/store/atom';
import { useRecoilValue } from 'recoil';

export const useSafeAreaSpacing = () => {
  const { topInset, bottomInset } = useRecoilValue(safeAreaInsetsState);

  const getBottomSpacing = (baseSpacing = 0) => bottomInset + baseSpacing;

  return {
    topInset,
    bottomInset,
    getBottomSpacing,
  };
};
